"use strict";
/** @module BryxApi.ManagementApi */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatType = void 0;
var models_1 = require("../../models");
var FormatType;
(function (FormatType) {
    FormatType["keyValue"] = "keyValue";
    FormatType["json"] = "json";
    FormatType["csv"] = "csv";
    FormatType["xml"] = "xml";
    FormatType["excel"] = "excel";
    FormatType["yaml"] = "yaml";
})(FormatType = exports.FormatType || (exports.FormatType = {}));
var ReportMixin = /** @class */ (function () {
    function ReportMixin() {
    }
    ReportMixin.prototype.searchReports = function (agencyId, limit, page, sortConfig, search, callback) {
        var _this = this;
        var urlParams = {
            order: sortConfig.direction,
        };
        if (limit != null) {
            urlParams['limit'] = limit;
        }
        if (page != null) {
            urlParams['page'] = page;
        }
        if (search != null) {
            urlParams['search'] = search;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, 'reports', models_1.MinimalReport.parse); }));
        };
        this.http.get("/agencies/" + agencyId + "/reports", urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    ReportMixin.prototype.getReportData = function (agencyId, reportId, format, download, dateFormat, timeZone, callback) {
        var wrappedCallback = function (request, response) {
            callback(request, response);
        };
        var params = {};
        if (format)
            params.format = format;
        if (download)
            params.download = 'true';
        if (dateFormat)
            params.dateFormat = dateFormat;
        if (timeZone)
            params.timeZone = timeZone;
        this.http.get("/agencies/" + agencyId + "/reports/" + reportId + "/data", params, this.unauthenticatedCallback(wrappedCallback), undefined, 'blob');
    };
    ReportMixin.prototype.getFullReport = function (agencyId, reportId, callback) {
        var wrappedCallback = function (request, response) {
            callback(request, response);
        };
        var params = {};
        this.http.get("/agencies/" + agencyId + "/reports/" + reportId, params, this.unauthenticatedCallback(wrappedCallback));
    };
    ReportMixin.prototype.postJobReport = function (agencyId, jobId, start, callback, end) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        var body = {
            jobId: jobId
        };
        this.http.post("/agencies/" + agencyId + "/reports/jobs", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    ReportMixin.prototype.postUserReport = function (agencyId, clientId, start, callback, end) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        var body = {
            clientId: clientId,
            start: start.getTime() / 1000,
            end: end ? end.getTime() / 1000 : undefined,
        };
        this.http.post("/agencies/" + agencyId + "/reports/responder", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    ReportMixin.prototype.postGroupReport = function (agencyId, groupId, start, callback, end) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        var body = {
            groupId: groupId,
            start: start.getTime() / 1000,
            end: end ? end.getTime() / 1000 : undefined,
        };
        this.http.post("/agencies/" + agencyId + "/reports/responders", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    return ReportMixin;
}());
exports.default = ReportMixin;
//# sourceMappingURL=ReportMixin.js.map